'use client'

import * as React from 'react'
import { cn } from '../../../lib/utils'
import { Icon } from '../Icon'
import { Button } from '../Button'

const WORDMARK_SRC = 'https://cdn.skedyul.it/logo-text-black.png'

export type ErrorPageAction = {
  label: string
  onClick: () => void
}

export type ErrorPageProps = {
  title?: string
  description?: string
  primaryAction?: ErrorPageAction
  secondaryAction?: ErrorPageAction
  digest?: string
  className?: string
}

export const ErrorPage: React.FC<ErrorPageProps> = ({
  title = 'Something went wrong',
  description = 'We hit an unexpected error. You can try again, or go back home.',
  primaryAction,
  secondaryAction,
  digest,
  className,
}) => {
  return (
    <div
      className={cn(
        'flex min-h-screen w-full flex-col items-center justify-center bg-background px-4 py-16 text-center',
        className,
      )}
    >
      <img
        src={WORDMARK_SRC}
        alt="Skedyul"
        className="mb-10 h-7 w-auto [[data-theme=dark]_&]:invert"
      />
      <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-muted">
        <Icon
          name="CircleAlert"
          className="h-8 w-8 text-muted-foreground"
          size={32}
        />
      </div>
      <h1 className="mb-2 text-xl font-semibold text-foreground">{title}</h1>
      <p className="mb-6 max-w-md text-sm text-muted-foreground">
        {description}
      </p>
      {(primaryAction || secondaryAction) && (
        <div className="flex flex-wrap items-center justify-center gap-2">
          {primaryAction && (
            <Button
              variant="default"
              size="lg"
              label={primaryAction.label}
              handleClick={primaryAction.onClick}
            />
          )}
          {secondaryAction && (
            <Button
              variant="outline"
              size="lg"
              label={secondaryAction.label}
              handleClick={secondaryAction.onClick}
            />
          )}
        </div>
      )}
      {digest ? (
        <p className="mt-6 font-mono text-xs text-muted-foreground">
          Error ID: {digest}
        </p>
      ) : null}
    </div>
  )
}

export default ErrorPage
